import { Icon } from '../../../layout/Icon.jsx';

export function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = 'تأكيد',
  cancelLabel = 'إلغاء',
  variant = 'primary',
  loading = false,
  children,
  onConfirm,
  onClose
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4" style={{ background: 'rgba(0,0,0,.45)' }}>
      <div className="card p-5 w-[440px] max-w-full space-y-3" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="text-[15px] font-bold">{title}</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>
        {message ? <div className="text-[13px] text-ink-2">{message}</div> : null}
        {children}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" className="btn" onClick={onClose} disabled={loading}>{cancelLabel}</button>
          <button
            type="button"
            className={variant === 'danger' ? 'btn btn-danger' : 'btn btn-primary'}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'جاري...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
